<span class="status-pill" [ngClass]="'status-pill--' + status()"> {{ statusName() }}</span>
